// components/CurrencySelect.jsx
import React from "react";
import { TextField, MenuItem } from "@material-ui/core";

/**
 * Currency selector component.
 *
 * @param {Object} props
 * @param {string} props.value - Current selected currency
 * @param {Function} props.onChange - Handler for change
 * @param {boolean} [props.disabled]
 * @param {boolean} [props.error]
 * @param {string} [props.helperText]
 */
export default function CurrencySelect({
    value,
    onChange = () => {},
    disabled = false,
    error,
    helperText,
}) {
    return (
        <TextField
            select
            label="Currency"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            fullWidth
            disabled={disabled}
            error={error}
            helperText={helperText}
        >
            <MenuItem value="USD">USD $</MenuItem>
            <MenuItem value="CAN">CAN $</MenuItem>
        </TextField>
    );
}
